/* eslint-disable */
import React from 'react';
import Salescaptain from './Salescaptain.svg';

const AboutSalesCap = () => (
  <div className="space-y-4">
    <div className="flex justify-center text-center text-xs font-semibold uppercase tracking-wider text-slate-500">
      {localStorage.getItem('h_name') ?? 'SALESCAPTAIN'} FOR BUSINESSES
    </div>
    <div className="flex flex-col items-center space-y-3">
      <div>
        <img className="max-h-12 w-auto object-contain" src={localStorage.getItem('h_url') ?? Salescaptain} alt="" />
      </div>
      <div className="text-center text-[13px] leading-relaxed text-slate-500">
        This profile is powered by {localStorage.getItem('h_name') ?? 'SalesCaptain'}.
        Businesses use {localStorage.getItem('h_name') ?? 'SalesCaptain'}
        everyday to get more reviews and manage
        all customer feedback. {localStorage.getItem('h_name') ?? 'SalesCaptain'} help local businesses to be found online with all 
        their reviews and accurate business information.
      </div>
    </div>
  </div>
);

export default AboutSalesCap;
